<template>
  <div class="wrapper">
    <div class="accept-envitation-widget">
      <div class="form-widget" v-if="getType == 1">
        <div class="logo">
          <img src="../assets/images/logo/new_logo.svg" alt />
        </div>
        <div class="title">Describe your participation in the project…</div>
        <div class="input-widget">
          <div class="input-group col-2" style="margin-bottom: 40px">
            <div class="input-wrapper">
              <label class="input-label">Project Name</label>
              <input type="text" disabled class="dark" v-model="object.name" placeholder="Project Name" />
            </div>
            <div class="input-wrapper">
              <label class="input-label">Company Name</label>
              <input type="text" disabled class="dark" v-model="object.company" placeholder="Company Name" />
            </div>
          </div>
          <div class="input-group col-4">
            <div class="input-wrapper">
              <label class="input-label">Role</label>
              <input type="text" class="light" v-model="object.role" placeholder="Role" />
            </div>
            <div class="input-wrapper">
              <label class="input-label">Time frame</label>
              <div class="range-date">
                <div class="check-label">
                  <label for="curr">Current Project</label>
                  <input type="checkbox" v-model="object.current" name="curr" id="curr" />
                </div>
                <datepicker :monday-first="true" placeholder="Start Date" v-model="object.from"
                  input-class="date-field-input" wrapper-class="date-field"></datepicker>
                <datepicker :monday-first="true" :disabled="object.current" placeholder="End Date" v-model="object.to"
                  input-class="date-field-input" wrapper-class="date-field"></datepicker>
              </div>
            </div>
            <div class="input-wrapper">
              <label class="input-label">Country</label>
              <select @change="
                (e) => {
                  $store.dispatch('GET_CITIES', { country: e.target.value });
                }
              " v-model="object.country">
                <option value="0">Select a Country</option>
                <template v-for="(country, index) in getCountries.countries">
                  <option :value="country.id">
                    {{ country.name | validate }}
                  </option>
                </template>
              </select>
            </div>
            <div class="input-wrapper">
              <label class="input-label">City</label>
              <select v-model="object.city">
                <option value="0">Select a City</option>
                <option v-for="(city, index) in getCities" :value="city.id">
                  {{ city.name | validate }}
                </option>
              </select>
            </div>
          </div>
          <div class="input-group col-1" style="margin-top: 40px">
            <div class="input-wrapper">
              <label class="input-label">Enter description</label>
              <html-editor v-model="object.description" id="edit-proj-descr" />
            </div>
          </div>
        </div>
        <div class="widget-options">
          <consultfied-button @click="
            (e) => {
              object.invite_type = 'project';
              sendRequest(object);
            }
          " class="btn-submit" :loading="loading">Submit</consultfied-button>
        </div>
      </div>
      <div class="form-widget" v-if="getType == 2">
        <div class="logo">
          <img src="../assets/images/logo/new_logo.svg" alt />
        </div>
        <div class="title">Describe your participation in the employment…</div>
        <div class="input-widget">
          <div class="input-group col-3" style="margin-bottom: 25px">
            <div class="input-wrapper">
              <label class="input-label">Company Name</label>
              <input type="text" class="dark" v-model="object.company" style="width: 300px" placeholder="Company Name" />
            </div>
            <div class="input-wrapper">
              <label class="input-label">Country</label>
              <select @change="
                (e) => {
                  $store.dispatch('GET_CITIES', { country: e.target.value });
                }
              " v-model="object.country">
                <option value="0">Select a Country</option>
                <template v-for="(country, index) in getCountries.countries">
                  <option :value="country.id">
                    {{ country.name | validate }}
                  </option>
                </template>
              </select>
            </div>
            <div class="input-wrapper">
              <label class="input-label">City</label>
              <select v-model="object.city">
                <option value="0">Select a City</option>
                <option v-for="(city, index) in getCities" :value="city.id">
                  {{ city.name | validate }}
                </option>
              </select>
            </div>
          </div>
          <div class="input-group col-2" style="margin-bottom: 25px">
            <div class="input-wrapper">
              <label class="input-label">Role</label>
              <input type="text" class="light" v-model="object.role" placeholder="Role" />
            </div>
            <div class="input-wrapper">
              <label class="input-label">Time Frame</label>
              <div class="range-date">
                <div class="check-label">
                  <label for="currr">Current Employment</label>
                  <input type="checkbox" name="curr" id="currr" />
                </div>
                <datepicker :monday-first="true" placeholder="Start Date" v-model="object.from"
                  input-class="date-field-input" wrapper-class="date-field"></datepicker>
                <datepicker :monday-first="true" :disabled="object.current" placeholder="End Date"
                  input-class="date-field-input" v-model="object.to" wrapper-class="date-field"></datepicker>
              </div>
            </div>
          </div>
          <div class="input-group col-1">
            <div class="input-wrapper">
              <label class="input-label">Enter Employment Description</label>
              <html-editor v-model="object.description" id="edit-empoy-descr" />
            </div>
          </div>
        </div>
        <div class="widget-options">
          <consultfied-button @click="
            (e) => {
              object.invite_type = 'employment';
              sendRequest(object);
            }
          " class="btn-submit" :loading="loading">Submit</consultfied-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Datepicker from "vuejs-datepicker";
import { mapGetters } from "vuex";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import moment from "moment";
import HtmlEditor from "@/components/helper/HtmlEditor.vue";
export default {
  name: "create-account-password",
  computed: {
    ...mapGetters(["getMeProfile", "getCountries", "getCities"]),
    userId() {
      return this.getMeProfile.user.id;
    },
    isInvited() {
      return !(
        this.$cookies.get("project-token") === null &&
        this.$cookies.get("employment-token") === null
      );
    },
    getInviteToken() {
      if (!this.isInvited) return "";
      else {
        return this.$cookies.get("project-token") === null
          ? this.$cookies.get("employment-token")
          : this.$cookies.get("project-token");
      }
    },
    getType() {
      if (!this.isInvited) return 0;
      else {
        return this.$cookies.get("project-token") === null ? 2 : 1;
      }
    },
  },
  components: { Datepicker, consultfiedButton, HtmlEditor },
  mounted() {
    this.$store.dispatch("GET_ME_PROFILE_DATA");
    this.$store.dispatch("GET_COUNTRIES");
    if (this.isInvited) {
      let vm = this;
      this.$store
        .dispatch("ACCOUNT_REGISTER_VIA_INVITE", {
          type: this.getType,
          reference: this.getInviteToken,
        })
        .then((res) => {
          vm.object.name = res.data.name;
          vm.object.from = res.data.from;
          vm.object.to = res.data.to;
          if (res.data.company) {
            vm.object.company = res.data.company.name;
          }
          vm.object.description = res.data.description;
        })
        .catch((e) => {
          console.log(e);
        });
    }
    let email = this.$route.query.email;
    if (email) {
      this.email = email;
    }
  },
  data() {
    return {
      loading: false,
      password: "",
      confirmPassword: "",
      email: "",
      message: "",
      errorLoggingIn: false,
      showModal: false,
      object: {
        name: "",
        role: "",
        company: "",
        from: "",
        to: "",
        current: false,
        description: "",
        country: 0,
        city: 0,
      },
    };
  },
  methods: {
    moment,
    startProgressBar() {
      this.loader.loading = true;
      this.loader.isSuccess = false;
      this.loader.message = "";
    },
    stopProgressBar() {
      this.loader.loading = false;
    },
    sendRequest(data) {
      let vm = this;
      vm.loading = true;
      if (data.from) {
        data.from = moment(data.from).format("YYYY-MM-DD");
      }
      if (data.to) {
        data.to = moment(data.to).format("YYYY-MM-DD");
      }
      if (this.userId) {
        data.user_id = this.userId;
        data.reference = this.getInviteToken;
        vm.$store
          .dispatch("SUBMIT_INVITE_PARTICIPATION_INFO", data)
          .then((response) => {
            vm.loading = false;
            vm.$cookies.remove("project-token");
            vm.$cookies.remove("employment-token");
            vm.$router.push({ name: "consultant-profile" });
          })
          .catch((error) => {
            vm.loading = false;
            vm.errorLoggingIn = true;
            error.response.data.error.forEach((errorMessage, index) => {
              if (index + 1 < error.response.data.error.length)
                //Not the last element
                vm.message += errorMessage;
              else vm.message += "\n" + errorMessage;
            });
          })
          .finally(() => { });
      } else {
        this.$store.dispatch("GET_ME_PROFILE_DATA").then((response) => {
          this.sendRequest(data);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/main";
@import url("https://fonts.googleapis.com/css?family=Shadows+Into+Light");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  text-align: center;
  overflow: hidden;
  background-image: url("../assets/images/backgrounds/background__white__web.svg") !important;
  background-size: cover;
}

.__container {
  position: relative;
  display: inline-block;

  @media (min-width: 300px) and (max-width: 630px) {}

  .form {
    display: flex;
    align-items: center;
    flex-direction: column;

    .logo {
      margin-top: 40px;
      margin-bottom: 40px;

      @media (min-width: 300px) and (max-width: 630px) {
        position: relative;
      }
    }

    .message {
      margin-top: 30px;
      border-radius: 5px;
      padding: 2px 40px;
      color: #fff;
    }

    .success {
      background: rgba(24, 133, 173, 0.3);
    }

    .error {
      background: rgba(128, 0, 0, 0.3);
    }

    .login_form {
      margin-top: 40px;
      text-align: left;

      @media (min-width: 300px) and (max-width: 630px) {
        padding-left: 20px;
        padding-right: 20px;
      }

      h2 {
        margin-bottom: 30px;
        font-size: 18px;
        font-weight: normal;
      }

      .label-password {
        margin-top: 30px;
      }

      .label {
        color: #000;
        font-weight: lighter;
        font-size: 14px;
        margin-bottom: 5px;
        margin-left: 20px;
      }

      .error_input {
        border: 1px solid crimson !important;
        color: crimson;
      }

      .error-msg {
        color: crimson;
        text-align: left;
      }

      .input:focus {
        outline: none !important;
        box-shadow: none;
      }

      input[type="text"],
      input[type="password"],
      select {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
        width: 400px;
        padding: 10px;
        margin-bottom: 20px;
        background-color: #ffffff;

        @media (min-width: 300px) and (max-width: 630px) {
          width: 300px;
        }

        border-radius: 5px;
        background-size: 15px 15px;
        background-origin: content-box;
        background-repeat: no-repeat;

        &:focus {
          outline: none;
        }
      }

      .input-group {
        display: flex;
        margin-top: 30px;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        margin-bottom: 20px;
      }

      .email {
        background: url(../assets/icons/mail.png) right;
      }

      .password {
        background: url(../assets/icons/key.png) right;
      }

      .bottom {
        display: flex;
        margin-top: 50px;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .signup {
          color: #1885ad !important;
          margin-top: 10px;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }

      input[type="button"] {
        background: #1885ad;
        width: 150px;
        padding: 7px;
        border-radius: 5px;
        color: #fff;
        text-align: center;
      }

      input[type="checkbox"] {
        background-color: #ffffff;
      }
    }

    .logo,
    .login_form {
      display: flex;
      flex-direction: column;
    }

    .banner {
      margin-top: 30px;
    }

    .banner span {
      font-size: 16px;
      color: #000000;
      font-weight: lighter;
    }

    .banner h1 {
      font-weight: normal;
      text-align: center;
      font-size: 30px;
      color: #1ba5a4;
      margin-bottom: 2rem !important;
    }
  }
}

.accept-envitation-widget {
  display: flex;
  justify-content: center;
  background: #efefef;
  min-height: 100vh;
  padding-top: 90px;
  padding-bottom: 35px;

  .form-widget {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    $column-space: 20px;
    width: 800px;
    padding-top: $column-space;

    .logo {
      margin-bottom: 30px;

      img {
        width: 80px;
      }
    }

    .title {
      color: #1ba5a4;
      font-size: 30px;
      font-family: "Nunito", sans-serif;
      margin-bottom: $column-space;
    }

    .input-widget {
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;
      margin-bottom: $column-space;

      .input-group {
        display: grid;
        grid-column-gap: 20px;

        .input-wrapper {
          .input-label {
            display: block;
            font-family: "Nunito", sans-serif;
            margin-bottom: 5px;
            text-align: left;
          }

          input.dark {
            height: 47px;
            width: 100%;
            background: #efefef 0% 0% no-repeat padding-box;
            border-radius: 5px;
            padding: 0px 20px;
            color: #000;
            font-family: "Nunito", sans-serif;
            outline: none;
          }

          input.dark::placeholder {
            font-weight: 800;
          }

          input.light,
          select {
            height: 47px;
            width: 100%;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 2px 6px #00000029;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 0px 20px;
            color: #000;
            font-family: "Nunito", sans-serif;
            outline: none;
          }

          textarea {
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 3px #00000029;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 10px;
            outline: none;
            width: 100%;
          }

          .range-date {
            display: grid;
            grid-column-gap: 5px;
            grid-template-columns: auto auto;
            height: 47px;
            width: 100%;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 2px 6px #00000029;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 4px 0px;
            padding-right: 10px;
            position: relative;

            .check-label {
              position: absolute;
              z-index: 999;
              top: -19px;
              right: 0px;
              display: flex;
              justify-content: flex-end;
              align-items: center;

              label {
                width: calc(100% - 10px);
                text-align: right;
              }

              input {
                width: 10px;
                margin-left: 5px;
              }
            }

            .date-field {
              background: #efefef;
              margin-left: 5px;
              height: 36px;
              border-radius: 5px;
              padding: 8px 10px;
              width: 100%;

              .date-field-input {
                width: 100% !important;
              }
            }
          }
        }
      }

      .input-group.col-1 {
        grid-template-columns: auto;
      }

      .input-group.col-2 {
        grid-template-columns: auto auto;
      }

      .input-group.col-3 {
        grid-template-columns: auto auto auto;
      }

      .input-group.col-4 {
        grid-template-columns: auto auto auto auto;

        input,
        select {
          width: 147px;
        }
      }
    }

    .widget-options {
      margin-bottom: $column-space;

      .btn-submit {
        width: 234px;
        height: 48px;
        background: #1885ad 0% 0% no-repeat padding-box;
        border-radius: 5px;
        color: #fff;
        font-family: "Nunito", sans-serif;
        font-weight: 800;
        justify-content: center;
      }
    }
  }
}
</style>
